import { useState, useEffect } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { getAcademies } from '@/api/schools';
import type { Academie } from '@/types/school';

interface AcademieSelectProps {
  value: string | null | undefined;
  onChange: (codeAcademie: string) => void;
  disabled?: boolean;
}

/**
 * Select des académies, auto-chargé depuis l'API.
 * Renvoie '' quand « Aucune » est sélectionnée.
 */
export function AcademieSelect({ value, onChange, disabled }: AcademieSelectProps) {
  const [academies, setAcademies] = useState<Academie[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadAcademies = async () => {
      setLoading(true);
      try {
        const data = await getAcademies();
        setAcademies(data);
      } catch (err) {
        console.error('Error loading academies:', err);
      } finally {
        setLoading(false);
      }
    };
    loadAcademies();
  }, []);

  return (
    <Select
      value={value || 'none'}
      onValueChange={(v) => onChange(v === 'none' ? '' : v)}
      disabled={disabled || loading}
    >
      <SelectTrigger>
        <SelectValue placeholder={loading ? 'Chargement...' : 'Sélectionner une académie'} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="none">Aucune</SelectItem>
        {academies.map((academie) => (
          <SelectItem key={academie.code} value={academie.code}>
            {academie.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
